import React from 'react';
import './style.scss';

export interface UQColProps {
  children: React.ReactNode;
  span?: number;
}

const UQCol: React.FC<UQColProps> = ({ children, span = 1 }) => {
  return <div className={`col-${span}`}>{children}</div>;
};

export default UQCol;